/* WBR-1714 Removed 'touchEnd' event from this list as brightcove player micro controls are not working
 * We need to check this at later date when brightcove player supports passive event listeners.
*/
(window as unknown)['__zone_symbol__PASSIVE_EVENTS'] = ['scroll', 'touchstart'];
